export const COLUMN_CSS_VARIABLE = '--config-strip-size-grid-column-gap';
export const ROW_CSS_VARIABLE = '--config-strip-size-grid-row-gap';

export const fixColumnAndRowGap = (document: Document) => {
  const computedStyles = getComputedStyle(document.documentElement);
  // has to be in sync with variables from theme. $config-strip-size-grid-column-gap
  const columnGap = computedStyles.getPropertyValue(COLUMN_CSS_VARIABLE);
  const rowGap = computedStyles.getPropertyValue(ROW_CSS_VARIABLE);

  // do nothing
  if (
    (columnGap === '0px' && rowGap === '0px') ||
    (columnGap === '' && rowGap === '')
  ) {
    return () => ({});
  }

  return (zoom: number) => {
    if (zoom >= 100 && columnGap && rowGap) {
      document.documentElement.style.setProperty(
        COLUMN_CSS_VARIABLE,
        columnGap,
      );

      document.documentElement.style.setProperty(ROW_CSS_VARIABLE, rowGap);

      return;
    }

    if (zoom < 100 && zoom >= 80) {
      document.documentElement.style.setProperty(COLUMN_CSS_VARIABLE, '0.1vw');

      document.documentElement.style.setProperty(ROW_CSS_VARIABLE, '0.1vw');

      return;
    }

    if (zoom < 80 && zoom >= 50) {
      document.documentElement.style.setProperty(
        COLUMN_CSS_VARIABLE,
        '0.075vw',
      );

      document.documentElement.style.setProperty(ROW_CSS_VARIABLE, '0.075vw');

      return;
    }

    if (zoom < 50) {
      document.documentElement.style.setProperty(COLUMN_CSS_VARIABLE, '0.05vw');

      document.documentElement.style.setProperty(ROW_CSS_VARIABLE, '0.05vw');

      return;
    }
  };
};
